(function() {
  'use strict';

  const root = document.getElementById('mamourse-product-page');
  const variantSelect = document.getElementById('mamourse-variant-select');

  if (!root || !variantSelect) {
    return;
  }

  const PRODUCT_HANDLE = root.dataset.productHandle || 'pandallow-plush';
  const PRODUCT_TITLE = root.dataset.productTitle || 'Pandallow Breastfeeding Pillow';
  const WHATSAPP_NUMBER = '96181242131';
  const STOCK_SYNC_INTERVAL_MS = 60000;

  let currentIndex = 0;
  let quantity = 1;
  let isSyncingStock = false;
  let hasSyncedStock = false;
  let lastSyncSucceeded = false;
  let stockSyncTimer = null;

  const variants = [];

  for (let i = 0; i < variantSelect.options.length; i++) {
    const option = variantSelect.options[i];

    if (!option.value || !option.dataset.id) {
      continue;
    }

    let optionImages = [];

    try {
      optionImages = JSON.parse(option.dataset.photos || '[]');
    } catch (error) {
      optionImages = [];
    }

    variants.push({
      id: String(option.dataset.id),
      name: option.textContent.replace(/\s*\(Sold Out\)\s*$/i, '').trim(),
      optionValue: option.value,
      price: parseFloat(option.dataset.price) || 0,
      comparePrice: parseFloat(option.dataset.compare) || null,
      inStock: option.dataset.instock === 'true' ? true : (option.dataset.instock === 'false' ? false : null),
      handle: PRODUCT_HANDLE,
      images: Array.isArray(optionImages) ? optionImages : []
    });

    const originalSoldOutFallback = option.dataset.instock === 'false' || option.disabled === true;

    option.textContent = option.textContent.replace(/\s*\(Sold Out\)\s*$/i, '').trim();
    option.disabled = originalSoldOutFallback;
    option.dataset.instock = originalSoldOutFallback ? 'false' : (option.dataset.instock || 'unknown');

    if (originalSoldOutFallback) {
      option.textContent = `${option.textContent} (Sold Out)`;
      variants[variants.length - 1].inStock = false;
    }
  }

  let currentVariant = variants[0] || null;
  let currentImages = currentVariant && Array.isArray(currentVariant.images) ? [...currentVariant.images] : [];

  const mainImg = document.getElementById('mamourse-main-img');
  const dotsContainer = document.getElementById('mamourse-dots');
  const prevBtn = document.getElementById('mamourse-prev');
  const nextBtn = document.getElementById('mamourse-next');
  const quantityValue = document.getElementById('mamourse-quantity-value');
  const qtyDecrease = document.getElementById('mamourse-qty-decrease');
  const qtyIncrease = document.getElementById('mamourse-qty-increase');
  const addToCartBtn = document.getElementById('mamourse-add-to-cart');
  const buyNowBtn = document.getElementById('mamourse-buy-now');
  const whatsappBtn = document.getElementById('mamourse-whatsapp-btn');
  const successDiv = document.getElementById('mamourse-cart-success');
  const heroPrice = document.getElementById('mamourse-hero-price');
  const heroCompare = document.getElementById('mamourse-hero-compare');
  const heroBadge = document.getElementById('mamourse-hero-badge');
  const deliveryText = document.getElementById('mamourse-delivery-text');

  function normalizeName(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[-_]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function formatMoney(amount) {
    const value = Number(amount);

    if (!Number.isFinite(value)) {
      return '$0.00';
    }

    return `$${value.toFixed(2)}`;
  }

  function parseShopifyMoney(cents) {
    const amount = Number(cents);

    if (!Number.isFinite(amount)) {
      return 0;
    }

    return amount / 100;
  }

  function getLiveVariantName(liveVariant) {
    const title = String(liveVariant && liveVariant.title ? liveVariant.title : '').trim();

    if (title && title.toLowerCase() !== 'default title') {
      return title;
    }

    const option1 = String(liveVariant && liveVariant.option1 ? liveVariant.option1 : '').trim();

    if (option1 && option1.toLowerCase() !== 'default title') {
      return option1;
    }

    return PRODUCT_TITLE;
  }

  function getLiveVariantImage(liveVariant) {
    if (!liveVariant) {
      return '';
    }

    if (liveVariant.featured_image && liveVariant.featured_image.src) {
      return liveVariant.featured_image.src;
    }

    if (liveVariant.image && typeof liveVariant.image === 'string') {
      return liveVariant.image;
    }

    if (liveVariant.image && liveVariant.image.src) {
      return liveVariant.image.src;
    }

    return '';
  }

  function getProductImages(product) {
    if (!product || !Array.isArray(product.images)) {
      return [];
    }

    return product.images
      .map(image => {
        if (typeof image === 'string') {
          return image;
        }

        if (image && image.src) {
          return image.src;
        }

        return '';
      })
      .filter(Boolean);
  }

  function findLocalVariantForLiveVariant(liveVariant) {
    const liveId = String(liveVariant && liveVariant.id ? liveVariant.id : '');
    let found = variants.find(variant => String(variant.id) === liveId);

    if (found) {
      return found;
    }

    const liveName = normalizeName(getLiveVariantName(liveVariant));
    found = variants.find(variant => normalizeName(variant.name) === liveName);

    if (found) {
      return found;
    }

    return null;
  }

  function mergeLiveProductIntoLocalVariants(product) {
    const productImages = getProductImages(product);

    if (!product || !Array.isArray(product.variants)) {
      return;
    }

    product.variants.forEach(liveVariant => {
      if (!liveVariant || !liveVariant.id) {
        return;
      }

      const localVariant = findLocalVariantForLiveVariant(liveVariant);

      if (!localVariant) {
        return;
      }

      const liveImage = getLiveVariantImage(liveVariant);
      const mergedImages = [];

      if (liveImage) {
        mergedImages.push(liveImage);
      }

      localVariant.images.forEach(image => {
        if (image && !mergedImages.includes(image)) {
          mergedImages.push(image);
        }
      });

      productImages.forEach(image => {
        if (image && !mergedImages.includes(image)) {
          mergedImages.push(image);
        }
      });

      localVariant.id = String(liveVariant.id);
      localVariant.name = getLiveVariantName(liveVariant);
      localVariant.price = parseShopifyMoney(liveVariant.price);
      localVariant.comparePrice = liveVariant.compare_at_price ? parseShopifyMoney(liveVariant.compare_at_price) : null;
      localVariant.inStock = liveVariant.available === true;
      localVariant.images = mergedImages.length ? mergedImages : localVariant.images;
    });
  }

  function getCurrentVariantFromSelect() {
    const selectedOption = variantSelect.options[variantSelect.selectedIndex];

    if (!selectedOption) {
      return currentVariant || variants[0] || null;
    }

    const selectedId = String(selectedOption.dataset.id || '');
    const selectedValue = String(selectedOption.value || '');

    return variants.find(variant => String(variant.id) === selectedId)
      || variants.find(variant => String(variant.optionValue) === selectedValue)
      || currentVariant
      || variants[0]
      || null;
  }

  function setCurrentVariant(variant) {
    if (!variant) {
      return;
    }

    currentVariant = variant;
    currentImages = Array.isArray(currentVariant.images) ? [...currentVariant.images] : [];
    currentIndex = 0;
  }

  function updateQuantityDisplay() {
    if (quantityValue) {
      quantityValue.textContent = String(quantity);
    }
  }

  function updatePriceDisplay() {
    if (!currentVariant) {
      return;
    }

    if (heroPrice) {
      heroPrice.textContent = formatMoney(currentVariant.price);
    }

    if (heroCompare) {
      if (currentVariant.comparePrice && currentVariant.comparePrice > currentVariant.price) {
        heroCompare.textContent = formatMoney(currentVariant.comparePrice);
        heroCompare.style.display = 'inline';
      } else {
        heroCompare.textContent = '';
        heroCompare.style.display = 'none';
      }
    }

    if (heroBadge) {
      if (currentVariant.comparePrice && currentVariant.comparePrice > currentVariant.price) {
        const savePercent = Math.round(((currentVariant.comparePrice - currentVariant.price) / currentVariant.comparePrice) * 100);
        heroBadge.textContent = `Save ${savePercent}%`;
        heroBadge.style.display = 'inline-block';
      } else {
        heroBadge.textContent = '';
        heroBadge.style.display = 'none';
      }
    }
  }

  function updateButtons() {
    if (!currentVariant) {
      return;
    }

    if (isSyncingStock && !hasSyncedStock) {
      if (addToCartBtn) {
        addToCartBtn.disabled = true;
        addToCartBtn.textContent = 'Checking stock...';
      }

      if (buyNowBtn) {
        buyNowBtn.disabled = true;
        buyNowBtn.textContent = '⚡ Checking availability...';
      }

      if (deliveryText) {
        deliveryText.innerHTML = 'Checking live stock from Shopify...';
      }

      return;
    }

    if (currentVariant.inStock === false) {
      if (addToCartBtn) {
        addToCartBtn.disabled = true;
        addToCartBtn.textContent = 'Sold Out - Coming Soon';
      }

      if (buyNowBtn) {
        buyNowBtn.disabled = true;
        buyNowBtn.textContent = '⚡ Currently Unavailable';
      }

      if (whatsappBtn) {
        whatsappBtn.childNodes[whatsappBtn.childNodes.length - 1].nodeValue = ' Notify Me on WhatsApp';
      }

      if (deliveryText) {
        deliveryText.innerHTML = `Back in stock soon — <strong>${currentVariant.name}</strong> is currently unavailable`;
      }

      return;
    }

    if (addToCartBtn) {
      addToCartBtn.disabled = false;
      addToCartBtn.textContent = 'Add to Cart →';
    }

    if (buyNowBtn) {
      buyNowBtn.disabled = false;
      buyNowBtn.textContent = '⚡ Buy Now';
    }

    if (whatsappBtn) {
      whatsappBtn.childNodes[whatsappBtn.childNodes.length - 1].nodeValue = ' Order Through WhatsApp';
    }

    if (deliveryText) {
      if (hasSyncedStock && lastSyncSucceeded) {
        deliveryText.innerHTML = `Live Shopify stock confirmed — receive it in <strong>2-4 days</strong> in Lebanon`;
      } else {
        deliveryText.innerHTML = `Order now to receive it in <strong>2-4 days</strong> in Lebanon`;
      }
    }
  }

  function updateVariantOptions() {
    if (!variantSelect) {
      return;
    }

    const selectedVariantId = currentVariant ? String(currentVariant.id) : '';

    for (let i = 0; i < variantSelect.options.length; i++) {
      const option = variantSelect.options[i];

      if (!option.dataset.id) {
        continue;
      }

      const variant = variants.find(item => String(item.id) === String(option.dataset.id))
        || variants.find(item => String(item.optionValue) === String(option.value));

      if (!variant) {
        continue;
      }

      option.dataset.id = String(variant.id);
      option.dataset.price = String(variant.price);
      option.dataset.compare = variant.comparePrice ? String(variant.comparePrice) : '';
      option.dataset.instock = variant.inStock === true ? 'true' : (variant.inStock === false ? 'false' : 'unknown');
      option.textContent = variant.inStock === false ? `${variant.name} (Sold Out)` : variant.name;
      option.disabled = variant.inStock === false;

      if (String(variant.id) === selectedVariantId) {
        option.selected = true;
      }
    }

    if (!variantSelect.value && variants.length) {
      const firstAvailable = variants.find(variant => variant.inStock === true) || variants[0];

      if (firstAvailable) {
        const matchingOption = Array.from(variantSelect.options).find(option => String(option.dataset.id) === String(firstAvailable.id));

        if (matchingOption) {
          matchingOption.selected = true;
          setCurrentVariant(firstAvailable);
        }
      }
    }
  }

  function renderDots() {
    if (!dotsContainer) {
      return;
    }

    dotsContainer.innerHTML = '';

    currentImages.forEach((_, index) => {
      const dot = document.createElement('span');
      dot.className = 'mamourse-dot';

      if (index === currentIndex) {
        dot.classList.add('active');
      }

      dot.addEventListener('click', () => showImage(index));
      dotsContainer.appendChild(dot);
    });
  }

  function updateActiveDots() {
    const dots = document.querySelectorAll('.mamourse-dot');

    dots.forEach((dot, index) => {
      dot.classList.toggle('active', index === currentIndex);
    });
  }

  function showImage(index) {
    if (!currentImages.length) {
      return;
    }

    currentIndex = (index + currentImages.length) % currentImages.length;

    if (mainImg) {
      mainImg.src = currentImages[currentIndex];
      mainImg.alt = `${PRODUCT_TITLE} - ${currentVariant ? currentVariant.name : ''}`;
    }

    updateActiveDots();
  }

  function refreshProductUI() {
    updatePriceDisplay();
    renderDots();
    showImage(0);
    updateActiveDots();
    updateButtons();
  }

  function showMessage(message, isError) {
    if (!successDiv) {
      return;
    }

    successDiv.textContent = message;
    successDiv.style.color = isError ? '#E53E3E' : '#A39385';
    successDiv.classList.add('show');

    setTimeout(() => {
      successDiv.classList.remove('show');
      successDiv.style.color = '#A39385';
    }, 2500);
  }

  async function fetchJson(url, options) {
    const response = await fetch(url, Object.assign({
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json'
      }
    }, options || {}));

    let data = null;
    const contentType = response.headers.get('content-type') || '';

    if (contentType.includes('application/json')) {
      data = await response.json().catch(() => null);
    } else {
      data = await response.text().catch(() => null);
    }

    if (!response.ok) {
      let message = `Request failed: ${response.status}`;

      if (data && typeof data === 'object') {
        message = data.description || data.message || message;
      } else if (typeof data === 'string' && data.trim()) {
        message = data.trim();
      }

      throw new Error(message);
    }

    return data;
  }

  async function syncStockFromShopify(options) {
    const opts = Object.assign({ silent: true, preserveSelection: true }, options || {});

    if (isSyncingStock) {
      return lastSyncSucceeded;
    }

    const selectedVariantBeforeSync = getCurrentVariantFromSelect();
    const selectedVariantId = selectedVariantBeforeSync ? String(selectedVariantBeforeSync.id) : '';

    isSyncingStock = true;
    updateButtons();

    try {
      const product = await fetchJson(`/products/${PRODUCT_HANDLE}.js?t=${Date.now()}`);

      mergeLiveProductIntoLocalVariants(product);

      let nextVariant = selectedVariantId
        ? variants.find(variant => String(variant.id) === selectedVariantId)
        : null;

      if (!nextVariant) {
        nextVariant = getCurrentVariantFromSelect();
      }

      if (!nextVariant) {
        nextVariant = variants.find(variant => variant.inStock === true) || variants[0] || null;
      }

      setCurrentVariant(nextVariant);
      updateVariantOptions();
      refreshProductUI();

      hasSyncedStock = true;
      lastSyncSucceeded = true;

      console.log('✅ Mamourse live stock synced from Shopify:', variants.map(variant => ({
        id: variant.id,
        name: variant.name,
        available: variant.inStock
      })));

      return true;
    } catch (error) {
      hasSyncedStock = true;
      lastSyncSucceeded = false;

      console.warn('⚠️ Mamourse live stock sync failed. The Add to Cart / Buy Now action will still be verified by Shopify.', error);

      if (!opts.silent) {
        showMessage('Live stock refresh failed. Shopify will verify stock when you add to cart.', false);
      }

      setCurrentVariant(getCurrentVariantFromSelect());
      updateVariantOptions();
      refreshProductUI();

      return false;
    } finally {
      isSyncingStock = false;
      updateButtons();
    }
  }

  async function addVariantToShopifyCart(variantId, itemQuantity) {
    return fetchJson('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: Number(itemQuantity)
      })
    });
  }

  async function clearCartAndBuyNow(variantId, itemQuantity) {
    await fetchJson('/cart/clear.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    });

    await addVariantToShopifyCart(variantId, itemQuantity);
    window.location.href = '/checkout';
  }

  function getCartProductData() {
    return {
      variant_id: currentVariant.id,
      variantId: currentVariant.id,
      variant_title: currentVariant.name,
      variantTitle: currentVariant.name,
      title: PRODUCT_TITLE,
      price: currentVariant.price,
      quantity: quantity,
      image: currentImages[0] || '',
      handle: PRODUCT_HANDLE,
      properties: {
        Design: currentVariant.name
      }
    };
  }

  async function addToCart() {
    if (!currentVariant) {
      return;
    }

    const button = addToCartBtn;
    const originalText = button ? button.textContent : '';

    if (button) {
      button.disabled = true;
      button.textContent = 'Checking stock...';
    }

    await syncStockFromShopify({ silent: true, preserveSelection: true });

    if (currentVariant.inStock === false) {
      updateButtons();
      showMessage(`${currentVariant.name} is out of stock.`, true);
      return;
    }

    if (button) {
      button.disabled = true;
      button.textContent = 'Adding...';
    }

    try {
      const cartProductData = getCartProductData();

      if (typeof window.addToCart === 'function') {
        window.addToCart(cartProductData);
      } else {
        await addVariantToShopifyCart(currentVariant.id, quantity);

        if (typeof window.openCartDrawer === 'function') {
          window.openCartDrawer();
        }

        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:updated'));
      }

      showMessage(`${quantity} × ${PRODUCT_TITLE} - ${currentVariant.name} added to cart successfully!`, false);
    } catch (error) {
      await syncStockFromShopify({ silent: true, preserveSelection: true });
      showMessage(error.message || 'Error adding to cart. Please try again.', true);
    } finally {
      setTimeout(() => {
        if (button) {
          button.disabled = currentVariant.inStock === false;
          button.textContent = originalText || (currentVariant.inStock === false ? 'Sold Out - Coming Soon' : 'Add to Cart →');
        }

        updateButtons();
      }, 700);
    }
  }

  async function buyNowRedirect() {
    if (!currentVariant || !buyNowBtn) {
      return;
    }

    const originalText = buyNowBtn.textContent;

    buyNowBtn.disabled = true;
    buyNowBtn.textContent = 'Checking stock...';

    await syncStockFromShopify({ silent: true, preserveSelection: true });

    if (currentVariant.inStock === false) {
      updateButtons();
      showMessage(`${currentVariant.name} is out of stock.`, true);
      return;
    }

    buyNowBtn.disabled = true;
    buyNowBtn.textContent = 'Redirecting...';

    try {
      await clearCartAndBuyNow(currentVariant.id, quantity);
    } catch (error) {
      await syncStockFromShopify({ silent: true, preserveSelection: true });
      showMessage(error.message || 'Error processing. Please try again.', true);

      setTimeout(() => {
        buyNowBtn.disabled = currentVariant.inStock === false;
        buyNowBtn.textContent = originalText || (currentVariant.inStock === false ? '⚡ Currently Unavailable' : '⚡ Buy Now');
        updateButtons();
      }, 900);
    }
  }

  function openWhatsApp() {
    if (!currentVariant) {
      return;
    }

    const totalPrice = (currentVariant.price * quantity).toFixed(2);
    let message = '';

    if (currentVariant.inStock === false) {
      message =
        `🛍️ *Restock Request*\n\n` +
        `📦 *Product:* ${PRODUCT_TITLE}\n` +
        `🎨 *Design:* ${currentVariant.name}\n` +
        `🧾 *Variant ID:* ${currentVariant.id}\n\n` +
        `👋 Please notify me when this design is back in stock. Thank you!`;
    } else {
      message =
        `🛍️ *New Order Inquiry*\n\n` +
        `📦 *Product:* ${PRODUCT_TITLE}\n` +
        `🎨 *Design:* ${currentVariant.name}\n` +
        `🧾 *Variant ID:* ${currentVariant.id}\n` +
        `🔢 *Quantity:* ${quantity}\n` +
        `💰 *Price per item:* ${formatMoney(currentVariant.price)}\n` +
        `💵 *Total:* $${totalPrice}\n\n` +
        `👋 I'm interested in this product. Please let me know about availability and payment options.`;
    }

    const whatsappURL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
    window.open(whatsappURL, '_blank');
  }

  function initVariantSelect() {
    variantSelect.addEventListener('change', function() {
      const nextVariant = getCurrentVariantFromSelect();

      if (!nextVariant) {
        return;
      }

      setCurrentVariant(nextVariant);
      refreshProductUI();
    });
  }

  function initGallery() {
    if (prevBtn) {
      prevBtn.addEventListener('click', () => showImage(currentIndex - 1));
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => showImage(currentIndex + 1));
    }

    let startX = 0;

    if (mainImg) {
      mainImg.addEventListener('touchstart', event => {
        startX = event.touches[0].clientX;
      }, { passive: true });

      mainImg.addEventListener('touchend', event => {
        const diff = event.changedTouches[0].clientX - startX;

        if (Math.abs(diff) > 40) {
          showImage(currentIndex + (diff > 0 ? -1 : 1));
        }
      }, { passive: true });
    }
  }

  function initQuantity() {
    if (qtyDecrease) {
      qtyDecrease.addEventListener('click', () => {
        if (quantity > 1) {
          quantity -= 1;
          updateQuantityDisplay();
        }
      });
    }

    if (qtyIncrease) {
      qtyIncrease.addEventListener('click', () => {
        quantity += 1;
        updateQuantityDisplay();
      });
    }
  }

  function initActionButtons() {
    if (addToCartBtn) {
      addToCartBtn.addEventListener('click', addToCart);
    }

    if (buyNowBtn) {
      buyNowBtn.addEventListener('click', buyNowRedirect);
    }

    if (whatsappBtn) {
      whatsappBtn.addEventListener('click', openWhatsApp);
    }
  }

  function initCollapsibles() {
    const collapsibles = document.querySelectorAll('.mamourse-collapsible');

    collapsibles.forEach(collapsible => {
      const header = collapsible.querySelector('.mamourse-collapsible-header');
      const content = collapsible.querySelector('.mamourse-collapsible-content');
      const iconSpan = collapsible.querySelector('.mamourse-collapsible-icon');

      if (!header || !content || !iconSpan) {
        return;
      }

      header.addEventListener('click', () => {
        const isOpen = content.classList.contains('open');
        content.classList.toggle('open', !isOpen);
        iconSpan.textContent = isOpen ? '+' : '−';
      });

      content.classList.remove('open');
      iconSpan.textContent = '+';
    });
  }

  function initReviewsLink() {
    document.getElementById('mamourse-reviews-link')?.addEventListener('click', () => {
      const target = document.getElementById('shopify-product-reviews') || document.querySelector('[data-reviews]');

      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  function startAutoStockSync() {
    if (stockSyncTimer) {
      clearInterval(stockSyncTimer);
    }

    stockSyncTimer = setInterval(() => {
      syncStockFromShopify({ silent: true, preserveSelection: true });
    }, STOCK_SYNC_INTERVAL_MS);

    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) {
        syncStockFromShopify({ silent: true, preserveSelection: true });
      }
    });

    window.addEventListener('focus', () => {
      syncStockFromShopify({ silent: true, preserveSelection: true });
    });
  }

  function initialize() {
    setCurrentVariant(getCurrentVariantFromSelect());
    updateQuantityDisplay();
    updatePriceDisplay();
    renderDots();
    showImage(0);
    initVariantSelect();
    initGallery();
    initQuantity();
    initActionButtons();
    initCollapsibles();
    initReviewsLink();
    updateVariantOptions();
    updateButtons();

    syncStockFromShopify({ silent: true, preserveSelection: true }).then(() => {
      updateButtons();
    });

    startAutoStockSync();
  }

  initialize();
})();
